import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

export interface UnsavedChangesBottomSheetProps {
  modalState: UseModalState;
  onSave: () => void;
  onDiscard: () => void;
}

export function UnsavedChangesBottomSheet(props: UnsavedChangesBottomSheetProps) {
  const { modalState, onSave, onDiscard } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" onClick={onSave}>
            Save
          </Button>
          <Button fullWidth variant="destructive" onClick={onDiscard}>
            Discard
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        hasFooter
        illustrationType="document-review"
        title="Save changes?"
        description="You have unsaved changes."
      />
    </BottomSheet>
  );
}
